import { useEffect, useState } from 'react'

import useDebounce from './useDebounce'
import PropTypes from 'prop-types'

const useWindowSize = (delay = 300) => {
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  })

  const debouncedSize = useDebounce(size, delay)

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width:
          document.documentElement.clientWidth || document.body.clientWidth,
        height:
          document.documentElement.clientHeight || document.body.clientHeight,
      })
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return debouncedSize
}
export default useWindowSize

useWindowSize.propTypes = {
  delay: PropTypes.number,
}
